import * as React from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({ pages, onPageChange }: { pages: number, onPageChange: any }) => {
  return (
    <ReactPaginate
      pageCount={pages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={({ selected }: any) => onPageChange({ page: selected + 1})}
      containerClassName={'pagination justify-content-end'}
      pageClassName={'page-item'}
      pageLinkClassName={'page-link'}
      activeClassName={'active'}
      disableInitialCallback={true}
      previousClassName={'page-item'}
      nextClassName={'page-item'}
      previousLinkClassName={'page-link'}
      nextLinkClassName={'page-link'}
    />
  );
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Shared/Pagination.tsx